import Icon from "@web-ui/components/Icon";
import StatusDot from "@web-ui/components/StatusDot";
import { href } from "@/lib/route";
import { pillText } from "@/publishing/changes";
import { useStudio } from "./studio";

/**
 * The persistent pill in the top bar (section 2): "3 changes not live · Review & publish", or "All
 * changes are live". Always a link to Review & publish. On phones the words shorten to the count;
 * the link's name stays the whole sentence.
 */
export function ChangesPill({ current }: { current: boolean }) {
  const { client, changes } = useStudio();
  if (!changes) return null;
  const count = changes.changes.length;
  const pending = count > 0 || !changes.known;
  // `known` is always true now (the backend works out what an older publish held), kept for older deployments.
  const text = !changes.known ? "Review & publish" : pillText(count);
  return (
    <a
      href={href({ brand: client.brand.id, section: "review" })}
      aria-current={current ? "page" : undefined}
      className="button button--tertiary button--sm gap-2 !px-3"
      aria-label={pending ? `${text}. Review & publish` : `${text}. See what is live`}
    >
      {pending ? <StatusDot tone="warning" label="Changes not live" /> : <Icon name="check-circle" size={4} className="fill-positive-stroke" />}
      <span className="max-md:hidden">{text}</span>
      <span className="md:hidden tabular-nums">{pending ? count : "Live"}</span>
      {pending && changes.known ? <><span className="text-t-tertiary max-md:hidden" aria-hidden="true">·</span><span className="max-md:hidden">Review & publish</span></> : null}
    </a>
  );
}
